import { useTranslation } from 'react-i18next';

const benefits = [
  {
    icon: 'ri-user-star-line',
    titleKey: 'benefits.specialized.title',
    descKey: 'benefits.specialized.desc'
  },
  {
    icon: 'ri-lightbulb-line',
    titleKey: 'benefits.efficiency.title',
    descKey: 'benefits.efficiency.desc'
  },
  {
    icon: 'ri-line-chart-line',
    titleKey: 'benefits.roi.title',
    descKey: 'benefits.roi.desc'
  },
  {
    icon: 'ri-team-line',
    titleKey: 'benefits.partnership.title',
    descKey: 'benefits.partnership.desc'
  }
];

export default function Benefits() {
  const { t } = useTranslation();

  return (
    <section id="benefits" className="py-24 bg-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, #e5e7eb 35px, #e5e7eb 70px)'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-[5%] relative z-10">
        <div className="grid grid-cols-5 gap-16">
          <div className="col-span-2 relative">
            <div className="absolute inset-0 flex items-center justify-center opacity-5 select-none">
              <span className="text-[200px] font-bold text-gray-300">GP</span>
            </div>
            
            <div className="relative z-10">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-1 h-12 bg-orange-500"></div>
                <span className="text-xs font-semibold tracking-wider text-gray-600 uppercase">{t('benefits.title')}</span>
              </div>
              
              <h2 className="text-5xl font-bold text-gray-900 leading-tight">
                {t('benefits.subtitle')}
              </h2>
            </div>
          </div>

          <div className="col-span-3 space-y-10">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-start gap-6 group">
                <div className="flex-shrink-0 w-20 h-20 rounded-full bg-[#14B8A6]/10 flex items-center justify-center group-hover:bg-[#14B8A6]/20 transition-colors">
                  <i className={`${benefit.icon} text-5xl text-[#14B8A6]`}></i>
                </div>
                
                <div className="flex-1 pt-2">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    {t(benefit.titleKey)}
                  </h3>
                  <p className="text-base text-gray-600 leading-relaxed">
                    {t(benefit.descKey)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
